import { AddEmployee as AddEmployeeComponent } from "../../Components";

const AddEmployee = () => {
  return (
      <AddEmployeeComponent />
  );
};

export default AddEmployee;
